//hooks
import React, { useState } from 'react';
import { NotificationConsumer } from '../hooks/context/NotificationContext';
import { UserConsumer } from '../hooks/context/UserContext';

//type
import { otpReqType } from '../api/otp/type/OtpType';

//api
import { PostOtpApi } from '../api/otp/PostOtpApi';
import { useApi } from '../hooks/useApi';

//mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//otp library
import OtpInput from 'react-otp-input';

//image
import login_logo from "../assets/login/login_logo.png"

interface otpProps {
    openOtp: boolean
    setOpenOtp:(open:boolean) =>void
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
    children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Otp = ({openOtp, setOpenOtp} :otpProps) => {

    const { t } = useTranslation();
    const [otp, setOtp] = useState<string>('');
    let {userData, setUserData} = UserConsumer()
    const {
    loading: otpLoading,
    error: otpError,
    HandlerApi: postOtp
    } = useApi(PostOtpApi, "Post");
    
    const handleClose = () => {
        setOpenOtp(false);
    };

    const handleOtp = async(payload:otpReqType)=> {
        const result = await postOtp(payload);
        console.log('otp successful:');
        setUserData(result.data)
        setOpenOtp(false);
        setOtp('')
    }

    return (
        <div>
            <Dialog 
            open={openOtp}
            onClose={handleClose}
            slots={{
            transition: Transition,
            }}
            disableRestoreFocus
            >
                <DialogTitle className='flex gap-3'>
                    <img className='w-[30px] h-[30px]' src={login_logo} alt='no=photo'/>
                    <p>{t("gettak")}</p>
                </DialogTitle>
                <DialogTitle className='flex justify-center !text-[30px]'>
                    <p>{t("enter_verification_code")}</p>
                </DialogTitle>
                <p className='text-[12px] text-center text-[#7F7F7F]'>{`${t("we_will_have_send_a_code_to")} ${userData?.phone}`}</p>
                <DialogContent>
                    <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={5}
                    renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props}
                    style={{
                        width: "3rem",
                        height: "3rem",
                        margin: "0 0.5rem",
                        fontSize: "1.5rem",
                        borderRadius: "0.5rem",
                        border: "2px solid #ccc",
                        textAlign: "center",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#4F46E5")}
                    onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                    />}
                    />
                </DialogContent>
                <DialogActions className={`!pb-5 ${i18n.language === "en" ? "!justify-start" : "!justify-start"}`}>
                    <Button className='w-full h-[30px] !bg-customerColor !text-white !rounded-full' onClick={() => handleOtp({ otp: otp, phone: String(userData?.phone) })}>
                    {otpLoading 
                    ? <CircularProgress size={22}/>
                    :t("confirm")
                    }
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Otp